import { JobProgressionStepStatus } from 'jobs/progression/JobProgression'
import { isEmpty, isNil } from 'lodash'

export enum JobProgressionStepFilterOption {
  None,
  NotStarted,
  JobStarted,
  OpenItems,
  DraftInReview,
  DraftRejected,
  DraftApproved,
  AuthorizationRequested,
  AuthorizationSigned,
  ReturnFiled,
}

export function matchesProgressionStepFilter(
  progressionStepStatus: JobProgressionStepStatus,
  progressionStepStatusFilters?: JobProgressionStepFilterOption[]
) {
  if (
    isNil(progressionStepStatusFilters) ||
    isEmpty(progressionStepStatusFilters)
  ) {
    return true
  }

  return progressionStepStatusFilters.some((filter) =>
    isJobProgressionStepMatch(progressionStepStatus, filter)
  )
}

function isJobProgressionStepMatch(
  progressionStepStatus: JobProgressionStepStatus,
  progressionStepStatusFilter: JobProgressionStepFilterOption
): boolean {
  switch (progressionStepStatusFilter) {
    case JobProgressionStepFilterOption.None:
      return (
        progressionStepStatus ===
        JobProgressionStepStatus.PROGRESSION_STEP_UNSPECIFIED
      )
    case JobProgressionStepFilterOption.NotStarted:
      return progressionStepStatus === JobProgressionStepStatus.NOT_STARTED
    case JobProgressionStepFilterOption.OpenItems:
      return progressionStepStatus === JobProgressionStepStatus.OPEN_ITEMS
    case JobProgressionStepFilterOption.JobStarted:
      return progressionStepStatus === JobProgressionStepStatus.JOB_STARTED
    case JobProgressionStepFilterOption.DraftInReview:
      return progressionStepStatus === JobProgressionStepStatus.DRAFT_IN_REVIEW
    case JobProgressionStepFilterOption.DraftApproved:
      return progressionStepStatus === JobProgressionStepStatus.DRAFT_APPROVED
    case JobProgressionStepFilterOption.DraftRejected:
      return progressionStepStatus === JobProgressionStepStatus.DRAFT_REJECTED
    case JobProgressionStepFilterOption.AuthorizationRequested:
      return (
        progressionStepStatus ===
        JobProgressionStepStatus.AUTHORIZATION_REQUESTED
      )
    case JobProgressionStepFilterOption.AuthorizationSigned:
      return (
        progressionStepStatus === JobProgressionStepStatus.AUTHORIZATION_SIGNED
      )
    case JobProgressionStepFilterOption.ReturnFiled:
      return progressionStepStatus === JobProgressionStepStatus.RETURN_FILED
    default:
      return false
  }
}
